import i18next, { type i18n as I18nInstance, type Resource } from 'i18next';
import { initReactI18next } from 'react-i18next';

// Общая i18next-обвязка платформы (V1.2-a; вынесена из `frontend/light/src/i18n`).
// Сами словари остаются в клиентах — core знает только КАК инициализировать,
// а не ЧТО переводить.
//
// initImmediate=false делает init синхронным — критично для SSR/тестов, чтобы
// первый рендер уже видел переводы, а не ключи. Повторный вызов на уже
// инициализированном инстансе — no-op (idempotent): модуль i18next глобальный,
// а точек входа у клиента две (main.tsx и setupTests.ts).

export interface CreateI18nOptions {
  /** Словари: `{ ru: { translation: {...} }, kk: {...} }`. */
  resources: Resource;
  /** Активный язык. Дефолт — `ru`. */
  lng?: string;
  /** Фолбэк, чтобы неполный перевод не ломал UI. Дефолт — `ru`. */
  fallbackLng?: string;
}

export function createI18n(options: CreateI18nOptions): I18nInstance {
  const { resources, lng = 'ru', fallbackLng = 'ru' } = options;
  if (!i18next.isInitialized) {
    i18next.use(initReactI18next).init({
      resources,
      lng,
      fallbackLng,
      interpolation: {
        escapeValue: false,
      },
      returnNull: false,
      initImmediate: false,
    });
  }
  return i18next;
}

export default i18next;
